import { render, staticRenderFns } from "./activities-details.vue?vue&type=template&id=325f0e74&scoped=true&"
import script from "./activities-details.vue?vue&type=script&lang=js&"
export * from "./activities-details.vue?vue&type=script&lang=js&"
import style0 from "./activities-details.vue?vue&type=style&index=0&id=325f0e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f0e74",
  null
  
)

component.options.__file = "activities-details.vue"
export default component.exports